import { media } from 'atoms/breakpoints/breakpoints';
import color from 'atoms/colors/colors';
import { spacing } from 'atoms/spacing/spacing';
import { fontFamily } from 'atoms/typography/typography';

const tabsThemeOverrides = {
  minHeight: 'unset',
  marginBottom: '36px',
  fontFamily: fontFamily.primaryFont,
  [media.sm]: {
    marginBottom: '52px',
  },
  [media.md]: {
    marginBottom: '60px',
  },
  '& .MuiTabs-flexContainer': {
    [media.lg]: {
      justifyContent: 'center',
    },
  },
};

const tabThemeOverrides = {
  fontFamily: fontFamily.primaryFont,
  textTransform: 'none',
  fontWeight: 'bold',
  minWidth: 'unset',
  minHeight: 'unset',
  marginRight: spacing[12],
  marginLeft: spacing[12],
  padding: '0',
  fontSize: '16px',
  lineHeight: '24px',
  [media.sm]: {
    fontSize: '18px',
    lineHeight: '28px',
  },
  '&:hover': {
    opacity: 1,
  },
};

export const lightTabs = {
  MuiTabs: {
    styleOverrides: {
      root: {
        ...tabsThemeOverrides,
        '& .MuiTabs-indicator': {
          backgroundColor: color.wave[800],
        },
      },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: {
        ...tabThemeOverrides,
        color: color.storm[900],
        '&:hover': {
          color: color.wave[800],
        },
        '&.Mui-selected': {
          color: color.wave[800],
        },
      },
    },
  },
};

export const darkTabs = {
  MuiTabs: {
    styleOverrides: {
      root: {
        ...tabsThemeOverrides,
        '& .MuiTabs-indicator': {
          backgroundColor: color.common.white,
        },
      },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: {
        ...tabThemeOverrides,
        color: color.storm[100],
        '&:hover': {
          color: color.common.white,
        },
        '&.Mui-selected': {
          color: color.common.white,
        },
      },
    },
  },
};
